import React, { useEffect, useState } from "react";
import { fetchScreenData } from "../../services/api";
import { HomeMasjid } from "./homeSettings";

interface LiveVideoProps {
  masjid: HomeMasjid;
  videoId: string;
  onClose: () => void;
}

const clockIn = (timeZone?: string) =>
  new Date().toLocaleTimeString("en-GB", { timeZone, hour: "numeric", minute: "2-digit" });

// A masjid's live YouTube broadcast, full screen, in YouTube's own player (branding and ads as
// YouTube shows them). The time is the masjid's, so Makkah shows Makkah time.
const LiveVideo: React.FC<LiveVideoProps> = ({ masjid, videoId, onClose }) => {
  const [timeZone, setTimeZone] = useState<string>();
  const [clock, setClock] = useState(() => clockIn());

  useEffect(() => {
    fetchScreenData(masjid.id, "home")
      .then((screen) => setTimeZone(screen.timeZone || undefined))
      .catch(() => {});
  }, [masjid.id]);

  useEffect(() => {
    setClock(clockIn(timeZone));
    const timer = window.setInterval(() => setClock(clockIn(timeZone)), 10_000);
    return () => window.clearInterval(timer);
  }, [timeZone]);

  return (
    <div className="hs-video" role="dialog" aria-modal="true" aria-label={`${masjid.name} live`}>
      <div className="hs-video-bar">
        <span className="hs-video-title">
          <span className="hs-live-dot" /> LIVE · {masjid.name}
        </span>
        <span className="hs-video-clock">{clock}</span>
        <button className="hs-bar-button" onClick={onClose}>
          Back to times
        </button>
      </div>
      <iframe
        className="hs-video-player"
        src={`https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&playsinline=1&rel=0`}
        title={`${masjid.name} live`}
        // The site is served with Referrer-Policy: same-origin, and YouTube refuses embeds that
        // send no Referer ("Error 153").
        referrerPolicy="strict-origin-when-cross-origin"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
      />
    </div>
  );
};

export default LiveVideo;
